import { BackgroundProps, DOMBuilder } from '../../../types';
import styles from './index.scss';
import { assign } from '..';

export class BackgroundBuilder {
  public static create(
    { backgroundColor, container }: BackgroundProps,
    domBuilder: DOMBuilder
  ): HTMLElement {
    container.className = styles.background;

    const backgroundStyle: Partial<CSSStyleDeclaration> = {
      backgroundColor: `${backgroundColor}`
    };

    assign(container.style, backgroundStyle);
    return container;
  }
}
